/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../settingshub/model/scope';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "fulfillment": {
        "nested": {
          "behaviors": {
            "nested": {
              "config": {
                "nested": {
                  "Attribution": {
                    "fields": {
                      "fieldPath": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "source": {
                        "type": ".squareup.fulfillment.behaviors.config.Attribution.Source",
                        "id": 2,
                        "rule": "optional"
                      },
                      "settingSource": {
                        "type": ".squareup.fulfillment.behaviors.config.Attribution.SettingSource",
                        "id": 3,
                        "rule": "optional"
                      },
                      "externalSource": {
                        "type": ".squareup.fulfillment.behaviors.config.Attribution.ExternalSource",
                        "id": 4,
                        "rule": "optional"
                      },
                      "details": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Source": {
                        "values": {
                          "SOURCE_UNSPECIFIED": 0,
                          "SETTING": 1,
                          "EXTERNAL": 2
                        }
                      },
                      "SettingSource": {
                        "fields": {
                          "scopeKey": {
                            "type": ".squareup.settingshub.model.ScopeKey",
                            "id": 1,
                            "rule": "optional"
                          },
                          "computedDefault": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalSource": {
                        "fields": {
                          "systemName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "referenceType": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "referenceId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.Attribution && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.Attribution?.nested?.Source && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.Attribution?.nested?.SettingSource && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.Attribution?.nested?.ExternalSource) {
  $root.addJSON(jsonData);
}

/**
 * Attribution information for a value.
 * Indicates the source of the value –– "Setting" (Settings-Hub) or "External" (others) --
 * along with additional metadata about that source.
 *
 * SOURCE Attribution @ squareup/fulfillment/behaviors/client/attributions.proto at 15:1
 */
export const Attribution = $root.lookupType('squareup.fulfillment.behaviors.config.Attribution');
fixType(Attribution);
Builder.createAndAttachToType(Attribution);
/**
 * SOURCE Source @ squareup/fulfillment/behaviors/client/attributions.proto at 27:3
 */
Attribution.Source = $root.lookupEnum('squareup.fulfillment.behaviors.config.Attribution.Source').values;
/**
 * SOURCE SettingSource @ squareup/fulfillment/behaviors/client/attributions.proto at 33:3
 */
Attribution.SettingSource = $root.lookupType('squareup.fulfillment.behaviors.config.Attribution.SettingSource');
fixType(Attribution.SettingSource);
Builder.createAndAttachToType(Attribution.SettingSource);
/**
 * SOURCE ExternalSource @ squareup/fulfillment/behaviors/client/attributions.proto at 38:3
 */
Attribution.ExternalSource = $root.lookupType('squareup.fulfillment.behaviors.config.Attribution.ExternalSource');
fixType(Attribution.ExternalSource);
Builder.createAndAttachToType(Attribution.ExternalSource);